package com.dualremotetest.web

import com.dualremotetest.LinkState
import com.dualremotetest.NetLink
import org.w3c.dom.CloseEvent
import org.w3c.dom.MessageEvent
import org.w3c.dom.WebSocket

/**
 * The relay connection in the browser (and the iPhone/iPad app's web view): a WebSocket whose messages wait in a
 * queue until the game reads them in its next frame, as OkHttpNetLink does on Android.
 */
class WebSocketNetLink(url: String) : NetLink {
    override var state = LinkState.CONNECTING
        private set
    override var closeReason: String? = null
        private set

    private val inbox = ArrayDeque<String>()
    private val ws: WebSocket? = runCatching { WebSocket(url) }.getOrElse { closed(it.message ?: "bad address"); null }

    init {
        ws?.onopen = { if (state == LinkState.CONNECTING) state = LinkState.OPEN }
        ws?.onmessage = { e -> (e as MessageEvent).data?.let { if (it is String) inbox.addLast(it) } }
        ws?.onclose = { e -> (e as CloseEvent).let { closed(it.reason.ifEmpty { "closed (${it.code})" }) } }
        ws?.onerror = { closed("connection failed") }
    }

    private fun closed(reason: String) {
        if (state == LinkState.CLOSED) return
        closeReason = reason
        state = LinkState.CLOSED
    }

    override fun send(text: String) {
        if (state == LinkState.OPEN) ws?.send(text)
    }

    override fun poll(): String? = inbox.removeFirstOrNull()

    override fun close() {
        runCatching { ws?.close(1000, "bye") }
        closed("closed here")
    }
}
